import { render, staticRenderFns } from "./TestScreeningCreate.vue?vue&type=template&id=2eddacd4&scoped=true&"
import script from "./TestScreeningCreate.vue?vue&type=script&lang=js&"
export * from "./TestScreeningCreate.vue?vue&type=script&lang=js&"
import style0 from "./TestScreeningCreate.vue?vue&type=style&index=0&id=2eddacd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eddacd4",
  null
  
)

export default component.exports